/**
 * Malay translations of backend response messages, keyed by the exact
 * English text the backend sends (CustomError / success messages).
 * Single source of truth for FE and BE localization — the frontend loads
 * this as the i18next 'backend' namespace; unknown messages pass through.
 */
export const backendMessagesMs: Record<string, string> = {
  '(#133010) Account not registered': '(#133010) Akaun tidak didaftarkan',
  '2FA has been successfully disabled for your account.':
    '2FA telah berjaya dinyahaktifkan untuk akaun anda.',
  '2FA has been successfully enabled for your account.':
    '2FA telah berjaya diaktifkan untuk akaun anda.',
  '2FA is already enabled for this user':
    '2FA sudah diaktifkan untuk pengguna ini',
  '2FA is not enabled for this user': '2FA tidak diaktifkan untuk pengguna ini',
  '2FA not configured correctly': '2FA tidak dikonfigurasi dengan betul',
  '2FA setup initiated. Please verify to complete setup.':
    'Persediaan 2FA telah dimulakan. Sila sahkan untuk melengkapkan persediaan.',
  '2FA setup not found. Please initiate 2FA setup first.':
    'Persediaan 2FA tidak ditemui. Sila mulakan persediaan 2FA terlebih dahulu.',
  '2FA status retrieved successfully.': 'Status 2FA berjaya diperoleh.',
  '2FA token required': 'Token 2FA diperlukan',
  'A positive "take" value (limit) is required for pagination.':
    'Nilai "take" yang positif (had) diperlukan untuk penomboran halaman.',
  'A valid business must be present in the request token to attach credit line':
    'Perniagaan yang sah mesti ada dalam token permintaan untuk melampirkan talian kredit',
  'AI results retrieved successfully': 'Hasil AI berjaya diperoleh',
  'API key added successfully': 'Kunci API berjaya ditambah',
  'API key deleted successfully': 'Kunci API berjaya dipadam',
  'API key has been revoked': 'Kunci API telah dibatalkan',
  'API key not found': 'Kunci API tidak ditemui',
  'API key revoked successfully': 'Kunci API berjaya dibatalkan',
  'API keys retrieved successfully': 'Kunci API berjaya diperoleh',
  'Access Token not found': 'Token Akses tidak ditemui',
  'Access Token not valid': 'Token Akses tidak sah',
  'Access denied': 'Akses dinafikan',
  'Access denied. VPC only.': 'Akses dinafikan. VPC sahaja.',
  'Account already exists': 'Akaun sudah wujud',
  'Analytics data is temporarily unavailable, please try again shortly':
    'Data analitik tidak tersedia buat sementara waktu, sila cuba lagi sebentar nanti',
  'Active API key set successfully': 'Kunci API aktif berjaya ditetapkan',
  'Active bots retrieved successfully': 'Bot aktif berjaya diperoleh',
  'Active call already exists for this client':
    'Panggilan aktif sudah wujud untuk pelanggan ini',
  'An update is already in progress for this function. Please wait a moment and try again.':
    'Kemas kini sedang dijalankan untuk fungsi ini. Sila tunggu sebentar dan cuba lagi.',
  'App not found!': 'Apl tidak ditemui!',
  'At least one of subject, description, or profile picture file is required':
    'Sekurang-kurangnya satu daripada subjek, penerangan atau fail gambar profil diperlukan',
  'At least one of tags or attributes must be provided':
    'Sekurang-kurangnya satu daripada tag atau atribut mesti diberikan',
  'Copilot chats are tied to a signed-in user and are not available to API keys.':
    'Sembang Copilot terikat kepada pengguna yang telah log masuk dan tidak tersedia untuk kunci API.',
  'Invalid session id': 'ID sesi tidak sah',
  'This chat has newer messages on another device. Reload to catch up before saving.':
    'Sembang ini mempunyai mesej yang lebih baharu pada peranti lain. Muat semula untuk mengemas kini sebelum menyimpan.',
  'audio file is required': 'fail audio diperlukan',
  Transcribed: 'Ditranskripsi',
  'Transcription failed': 'Transkripsi gagal',
  'Authenticated email missing': 'E-mel yang disahkan tiada',
  'Authentication required.': 'Pengesahan diperlukan.',
  'Authorization header is required.': 'Pengepala Authorization diperlukan.',
  "Authorization header must be formatted as 'Bearer [token]'.":
    "Pengepala Authorization mesti diformatkan sebagai 'Bearer [token]'.",
  'Authorization successful.': 'Keizinan berjaya.',
  'Balance added successfully': 'Baki berjaya ditambah',
  'before and beforeId must each be a single value':
    'before dan beforeId mestilah masing-masing satu nilai tunggal',
  'before must be a valid ISO timestamp':
    'before mestilah cap masa ISO yang sah',
  'beforeId must be sent together with before':
    'beforeId mesti dihantar bersama-sama dengan before',
  'Bill ID is required.': 'ID Bil diperlukan.',
  'Bill deleted successfully.': 'Bil berjaya dipadam.',
  'Bill fetched successfully.': 'Bil berjaya diperoleh.',
  'Bill not found.': 'Bil tidak ditemui.',
  'Bill updated successfully.': 'Bil berjaya dikemas kini.',
  'Billing data generated successfully.': 'Data pengebilan berjaya dijana.',
  'Bills fetched successfully.': 'Semua bil berjaya diperoleh.',
  'Blocked clients fetched successfully':
    'Pelanggan yang disekat berjaya diperoleh',
  'Books mapping fetched.': 'Pemetaan Books diperoleh.',
  'Books mapping is not enabled for this business.':
    'Pemetaan Books tidak diaktifkan untuk perniagaan ini.',
  'Books mapping updated.': 'Pemetaan Books dikemas kini.',
  'Bot results retrieved successfully': 'Hasil bot berjaya diperoleh',
  'Business Account ID or FB Access Token is missing!':
    'ID Akaun Perniagaan atau Token Akses FB tiada!',
  'Business has no Meta access token configured':
    'Perniagaan tidak mempunyai token akses Meta yang dikonfigurasi',
  'Business has no WhatsApp phone number configured':
    'Perniagaan tidak mempunyai nombor telefon WhatsApp yang dikonfigurasi',
  'Business ID is required': 'ID Perniagaan diperlukan',
  'Business WhatsApp credentials not configured':
    'Kelayakan WhatsApp perniagaan tidak dikonfigurasi',
  'Business deleted successfully!': 'Perniagaan berjaya dipadam!',
  'Business details are missing. Please add business details first!':
    'Butiran perniagaan tiada. Sila tambah butiran perniagaan terlebih dahulu!',
  'Business details are missing. Please add business details first.':
    'Butiran perniagaan tiada. Sila tambah butiran perniagaan terlebih dahulu.',
  'Business details are missing. Please complete WhatsApp setup first.':
    'Butiran perniagaan tiada. Sila lengkapkan persediaan WhatsApp terlebih dahulu.',
  'Business details are missing. So please add first business details!':
    'Butiran perniagaan tiada. Jadi sila tambah butiran perniagaan dahulu!',
  'Business does not have a Facebook Access Token.':
    'Perniagaan tidak mempunyai Token Akses Facebook.',
  'Business does not have a Facebook App ID. So please add Facebook App ID in WhatsApp API Setup!':
    'Perniagaan tidak mempunyai ID Apl Facebook. Sila tambah ID Apl Facebook dalam Persediaan API WhatsApp!',
  'Business has no orgId': 'Perniagaan tidak mempunyai orgId',
  'Business name updated successfully!':
    'Nama perniagaan berjaya dikemas kini!',
  'Business not found': 'Perniagaan tidak ditemui',
  'Business not found in your organization.':
    'Perniagaan tidak ditemui dalam organisasi anda.',
  'Business not found or does not belong to this organization':
    'Perniagaan tidak ditemui atau bukan milik organisasi ini',
  'Business not found or does not belong to this partner.':
    'Perniagaan tidak ditemui atau bukan milik rakan kongsi ini.',
  'Business not found!': 'Perniagaan tidak ditemui!',
  'Business not found.': 'Perniagaan tidak ditemui.',
  'Business phone number is not configured correctly':
    'Nombor telefon perniagaan tidak dikonfigurasi dengan betul',
  'Business setup correctly not found':
    'Persediaan perniagaan yang betul tidak ditemui',
  'Business setup is incomplete': 'Persediaan perniagaan tidak lengkap',
  'Business setup is incomplete. Missing fbAccessToken or businessAccountId.':
    'Persediaan perniagaan tidak lengkap. fbAccessToken atau businessAccountId tiada.',
  'Business updated successfully': 'Perniagaan berjaya dikemas kini',
  'Call accepted successfully!': 'Panggilan berjaya diterima!',
  'Call initiated successfully!': 'Panggilan berjaya dimulakan!',
  'Call messages retrieved successfully': 'Mesej panggilan berjaya diperoleh',
  'Call pre-accepted successfully!': 'Panggilan berjaya dipraterima!',
  'Call rejected successfully!': 'Panggilan berjaya ditolak!',
  'Call terminated successfully': 'Panggilan berjaya ditamatkan',
  'Call terminated successfully!': 'Panggilan berjaya ditamatkan!',
  'Campaign not found': 'Kempen tidak ditemui',
  'Cannot Verify Webhook Token!': 'Tidak Dapat Mengesahkan Token Webhook!',
  'Cannot delete $LATEST version': 'Tidak boleh memadam versi $LATEST',
  'Cannot delete a business with completed setup. Only incomplete setups can be deleted.':
    'Tidak boleh memadam perniagaan dengan persediaan yang telah selesai. Hanya persediaan yang tidak lengkap boleh dipadam.',
  'Cannot delete the last business. At least one business is required.':
    'Tidak boleh memadam perniagaan terakhir. Sekurang-kurangnya satu perniagaan diperlukan.',
  'Cannot revoke — at least one OWNER must retain access to each business.':
    'Tidak boleh membatalkan — sekurang-kurangnya satu OWNER mesti mengekalkan akses kepada setiap perniagaan.',
  'Cannot use "after" and "before" cursors simultaneously.':
    'Tidak boleh menggunakan kursor "after" dan "before" serentak.',
  'Chat completion successful': 'Penyempurnaan sembang berjaya',
  'Chatbot assigned to client successfully':
    'Chatbot berjaya ditugaskan kepada pelanggan',
  'Chatbot assignment removed from client':
    'Penugasan Chatbot dialih keluar daripada pelanggan',
  'Chatbot config retrieved': 'Konfigurasi Chatbot diperoleh',
  'Chatbot conversation triggered successfully':
    'Perbualan Chatbot berjaya dicetuskan',
  'Chatbot created successfully': 'Chatbot berjaya dicipta',
  'Chatbot deleted successfully': 'Chatbot berjaya dipadam',
  'Chatbot exported successfully': 'Chatbot berjaya dieksport',
  'Chatbot imported successfully': 'Chatbot berjaya diimport',
  'Chatbot not found': 'Chatbot tidak ditemui',
  'Chatbot nudges fetched successfully': 'Nudge Chatbot berjaya diperoleh',
  'Chatbot response generated successfully': 'Respons Chatbot berjaya dijana',
  'Chatbot retrieved successfully': 'Chatbot berjaya diperoleh',
  'Chatbot updated successfully': 'Chatbot berjaya dikemas kini',
  'Chatbots retrieved successfully': 'Senarai chatbot berjaya diperoleh',
  'ClickHouse analytics is not enabled': 'Analitik ClickHouse tidak diaktifkan',
  'ClickHouse is not available': 'ClickHouse tidak tersedia',
  'ClickHouse is unavailable; cannot generate bills.':
    'ClickHouse tidak tersedia; tidak dapat menjana bil.',
  'Client chat status updated successfully':
    'Status sembang pelanggan berjaya dikemas kini',
  'Client has not opted in': 'Pelanggan belum membuat pilihan masuk',
  'Client is blocked': 'Pelanggan disekat',
  'Client not found': 'Pelanggan tidak ditemui',
  'Clients created/updated successfully':
    'Pelanggan berjaya dicipta/dikemas kini',
  'Code executed': 'Kod dilaksanakan',
  'Code executed successfully': 'Kod berjaya dilaksanakan',
  'Code saved successfully': 'Kod berjaya disimpan',
  'Coexistence is not enabled for this business!':
    'Kewujudan bersama tidak diaktifkan untuk perniagaan ini!',
  'Compressed payload too large': 'Muatan termampat terlalu besar',
  'Contact not found': 'Kenalan tidak ditemui',
  'Contact updated successfully.': 'Kenalan berjaya dikemas kini.',
  'Copilot response received': 'Respons Copilot diterima',
  'Cost analytics retrieved successfully': 'Analitik kos berjaya diperoleh',
  'Could not find whatsapp_business_messaging scope with target_ids in granular_scopes':
    'Tidak dapat mencari skop whatsapp_business_messaging dengan target_ids dalam granular_scopes',
  'Could not prepare storage for upload. Please try again.':
    'Tidak dapat menyediakan storan untuk muat naik. Sila cuba lagi.',
  'Could not resolve a contact from the given identifiers':
    'Tidak dapat menentukan kenalan daripada pengecam yang diberikan',
  'Credit line attached successfully': 'Talian kredit berjaya dilampirkan',
  'Currency conversion failed.': 'Penukaran mata wang gagal.',
  'Daily engagement analytics retrieved successfully':
    'Analitik penglibatan harian berjaya diperoleh',
  'Debug context retrieved': 'Konteks nyahpepijat diperoleh',
  'Edit lock status': 'Status kunci suntingan',
  'Either phoneNumberId or businessId, clientWaNumber, and either text or messages are required':
    'Sama ada phoneNumberId atau businessId, clientWaNumber, dan sama ada text atau messages diperlukan',
  'Either text, media, or a button/list reply must be provided':
    'Sama ada teks, media atau balasan butang/senarai mesti diberikan',
  'Email is required': 'E-mel diperlukan',
  'Email is required!': 'E-mel diperlukan!',
  'Email verified. Your account is ready — please log in.':
    'E-mel disahkan. Akaun anda sedia — sila log masuk.',
  'Embed session created.': 'Sesi benam dicipta.',
  'Employee not found': 'Pekerja tidak ditemui',
  'Employee not found!': 'Pekerja tidak ditemui!',
  'Employee record not found': 'Rekod pekerja tidak ditemui',
  'Error 500': 'Ralat 500',
  'Error during message search': 'Ralat semasa carian mesej',
  'Error fetching business profile details!':
    'Ralat semasa mendapatkan butiran profil perniagaan!',
  'Error in JWT Token!': 'Ralat dalam Token JWT!',
  'Error in SSO authorization.': 'Ralat dalam keizinan SSO.',
  'Error in authorization.': 'Ralat dalam keizinan.',
  'Error in embedded signup': 'Ralat dalam pendaftaran terbenam',
  'Error in fetching single flow': 'Ralat semasa mendapatkan aliran tunggal',
  'Error updating business profile details!':
    'Ralat semasa mengemas kini butiran profil perniagaan!',
  'Error while marking message as read':
    'Ralat semasa menandakan mesej sebagai dibaca',
  'Estimate details fetched successfully.':
    'Butiran anggaran berjaya diperoleh.',
  'Estimate marked as accepted.': 'Anggaran ditandakan sebagai diterima.',
  'Estimate not found.': 'Anggaran tidak ditemui.',
  'Execution role is not configured. Please contact support.':
    'Peranan pelaksanaan tidak dikonfigurasi. Sila hubungi pihak sokongan.',
  Forbidden: 'Dilarang',
  'Facebook Access Token not found': 'Token Akses Facebook tidak ditemui',
  'Failed to accept call': 'Gagal menerima panggilan',
  'Failed to attach credit line for this business':
    'Gagal melampirkan talian kredit untuk perniagaan ini',
  'Failed to create Karix account for credit line':
    'Gagal mencipta akaun Karix untuk talian kredit',
  'Failed to create flow': 'Gagal mencipta aliran',
  'Failed to create template': 'Gagal mencipta templat',
  'Failed to create template with library. Please contact customer support':
    'Gagal mencipta templat dengan pustaka. Sila hubungi sokongan pelanggan',
  'Failed to create template. Please contact customer support':
    'Gagal mencipta templat. Sila hubungi sokongan pelanggan',
  'Failed to create versioned function.': 'Gagal mencipta fungsi berversi.',
  'Failed to delete hash templates': 'Gagal memadam templat hash',
  'Failed to delete template': 'Gagal memadam templat',
  'Failed to delete the flow': 'Gagal memadam aliran',
  'Failed to delete version': 'Gagal memadam versi',
  'Failed to deprecate the flow': 'Gagal menamatkan penggunaan aliran',
  'Failed to fetch JsonFlow': 'Gagal mendapatkan JsonFlow',
  'Failed to fetch analytics': 'Gagal mendapatkan analitik',
  'Failed to fetch call settings': 'Gagal mendapatkan tetapan panggilan',
  'Failed to fetch conversation analytics':
    'Gagal mendapatkan analitik perbualan',
  'Failed to fetch data localization region from Meta.':
    'Gagal mendapatkan rantau penyetempatan data daripada Meta.',
  'Failed to fetch data localization region.':
    'Gagal mendapatkan rantau penyetempatan data.',
  'Failed to fetch form responses due to a server error':
    'Gagal mendapatkan respons borang disebabkan ralat pelayan',
  'Failed to fetch meta acount health status!':
    'Gagal mendapatkan status kesihatan akaun Meta!',
  'Failed to fetch pricing analytics': 'Gagal mendapatkan analitik harga',
  'Failed to fetch template analytics': 'Gagal mendapatkan analitik templat',
  'Failed to fetch whatsapp commerce settings':
    'Gagal mendapatkan tetapan perdagangan WhatsApp',
  'Failed to generate Karix token for credit line':
    'Gagal menjana token Karix untuk talian kredit',
  'Failed to generate system prompt. Please try again.':
    'Gagal menjana prompt sistem. Sila cuba lagi.',
  'Failed to get response from AI. Please try again.':
    'Gagal mendapatkan respons daripada AI. Sila cuba lagi.',
  'Failed to initiate call': 'Gagal memulakan panggilan',
  'Failed to pre-accept call': 'Gagal mempraterima panggilan',
  'Failed to preview the flow': 'Gagal membuat pratonton aliran',
  'Failed to process templates': 'Gagal memproses templat',
  'Failed to publish the flow': 'Gagal menerbitkan aliran',
  'Failed to register phone number!': 'Gagal mendaftarkan nombor telefon!',
  'Failed to reject call': 'Gagal menolak panggilan',
  'Failed to request coexistence sync!':
    'Gagal meminta penyegerakan kewujudan bersama!',
  'Failed to retrieve template message analytics':
    'Gagal mendapatkan analitik mesej templat',
  'Failed to send typing indicator!': 'Gagal menghantar penunjuk menaip!',
  'Failed to subscribe to webhooks!': 'Gagal melanggan webhook!',
  'Failed to terminate call': 'Gagal menamatkan panggilan',
  'Failed to update call settings': 'Gagal mengemas kini tetapan panggilan',
  'Failed to update data localization region on Meta.':
    'Gagal mengemas kini rantau penyetempatan data di Meta.',
  'Failed to update data localization region.':
    'Gagal mengemas kini rantau penyetempatan data.',
  'Failed to update jwt token': 'Gagal mengemas kini token jwt',
  'Failed to update template': 'Gagal mengemas kini templat',
  'Failed to update the flow': 'Gagal mengemas kini aliran',
  'Failed to update whatsapp commerce settings':
    'Gagal mengemas kini tetapan perdagangan whatsapp',
  'Failed to upload through Resumable API':
    'Gagal memuat naik melalui Resumable API',
  'Fallback config deleted successfully':
    'Konfigurasi fallback berjaya dipadamkan',
  'Fallback config not found': 'Konfigurasi fallback tidak ditemui',
  'Fallback config saved successfully': 'Konfigurasi fallback berjaya disimpan',
  'Fallback configs fetched successfully':
    'Konfigurasi fallback berjaya diambil',
  'Fetch flows error': 'Ralat mengambil aliran',
  'Fetched data localization region.':
    'Rantau penyetempatan data berjaya diambil.',
  'Fetched function details': 'Butiran fungsi berjaya diambil',
  'Fetched versions': 'Versi berjaya diambil',
  'Field name too long.': 'Nama medan terlalu panjang.',
  'Field value too long.': 'Nilai medan terlalu panjang.',
  'File is required': 'Fail diperlukan',
  'File not accessible': 'Fail tidak boleh diakses',
  'File not found in request body!':
    'Fail tidak ditemui dalam badan permintaan!',
  'File too large. Please upload a smaller file.':
    'Fail terlalu besar. Sila muat naik fail yang lebih kecil.',
  'File type and file name are required!':
    'Jenis fail dan nama fail diperlukan!',
  'Filename is too long. Maximum 255 characters allowed.':
    'Nama fail terlalu panjang. Maksimum 255 aksara dibenarkan.',
  'Flow executed': 'Aliran dilaksanakan',
  'Function bundle not available': 'Himpunan fungsi tidak tersedia',
  'Function executed successfully': 'Fungsi berjaya dilaksanakan',
  'GST status fetched successfully.': 'Status GST berjaya diambil.',
  'GSTIN updated successfully.': 'GSTIN berjaya dikemas kini.',
  'Graph API Error': 'Ralat Graph API',
  'Group deletion requested': 'Pemadaman kumpulan diminta',
  'Group info retrieved': 'Maklumat kumpulan diperoleh',
  'Group settings update requested': 'Kemas kini tetapan kumpulan diminta',
  'HTTP request executed': 'Permintaan HTTP dilaksanakan',
  Hello: 'Helo',
  'Hello there': 'Helo, apa khabar',
  'Hello!': 'Helo!',
  Hi: 'Hai',
  'Hi there': 'Hai, apa khabar',
  'Incorrect or expired code. If it keeps failing, please start the sign-up again to get a new code.':
    'Kod tidak betul atau telah tamat tempoh. Jika masih gagal, sila mulakan pendaftaran semula untuk mendapatkan kod baharu.',
  'Invalid 2FA token': 'Token 2FA tidak sah',
  'Invalid 2FA token. Please provide a valid token to disable 2FA.':
    'Token 2FA tidak sah. Sila berikan token yang sah untuk menyahdayakan 2FA.',
  'Invalid 2FA token. Please try again.':
    'Token 2FA tidak sah. Sila cuba lagi.',
  'Invalid Google token': 'Token Google tidak sah',
  'Invalid HTTP request options': 'Pilihan permintaan HTTP tidak sah',
  'Invalid Pipecat secret': 'Rahsia Pipecat tidak sah',
  'Invalid Web Verification Token': 'Token Pengesahan Web tidak sah',
  'Invalid amount. Must be greater than 0.':
    'Amaun tidak sah. Mesti lebih besar daripada 0.',
  'Invalid business ID': 'ID perniagaan tidak sah',
  'Invalid business context': 'Konteks perniagaan tidak sah',
  'Invalid business id.': 'ID perniagaan tidak sah.',
  'Invalid config ID': 'ID konfigurasi tidak sah',
  'Invalid cursor format': 'Format kursor tidak sah',
  'Invalid date format. Expected YYYY-MM-DD format (e.g., "2025-11-01").':
    'Format tarikh tidak sah. Format YYYY-MM-DD dijangka (cth., "2025-11-01").',
  'Invalid date format. Use YYYY-MM-DD':
    'Format tarikh tidak sah. Gunakan YYYY-MM-DD',
  'Invalid destination phone number': 'Nombor telefon destinasi tidak sah',
  'Invalid email or password': 'E-mel atau kata laluan tidak sah',
  'Invalid email or password2.': 'E-mel atau password2 tidak sah.',
  'Invalid employee ID': 'ID pekerja tidak sah',
  'Invalid filename. Please use a safe filename without special characters.':
    'Nama fail tidak sah. Sila gunakan nama fail yang selamat tanpa aksara khas.',
  'Invalid message type': 'Jenis mesej tidak sah',
  'Invalid or missing orgId parameter.':
    'Parameter orgId tidak sah atau tiada.',
  'Invalid org ID': 'ID org tidak sah',
  'Invalid request data': 'Data permintaan tidak sah',
  'Invalid response data': 'Data respons tidak sah',
  'Invalid voice bot secret': 'Rahsia bot suara tidak sah',
  'Invalid webhook signature': 'Tandatangan webhook tidak sah',
  'Invite link reset': 'Pautan jemputan ditetapkan semula',
  'Invite link retrieved': 'Pautan jemputan diperoleh',
  'Invite valid': 'Jemputan sah',
  'Invoice URL fetched successfully.': 'URL invois berjaya diambil.',
  'Invoice is not available for this bill yet.':
    'Invois belum tersedia untuk bil ini.',
  'Iteration complete': 'Lelaran selesai',
  'Join requests approved': 'Permintaan menyertai diluluskan',
  'Join requests rejected': 'Permintaan menyertai ditolak',
  'Join requests retrieved': 'Permintaan menyertai diperoleh',
  'Journey not found': 'Journey tidak ditemui',
  'Just one': 'Hanya satu',
  'KARIX_ACCESS_TOKEN is not configured':
    'KARIX_ACCESS_TOKEN tidak dikonfigurasikan',
  'Legacy API key(s) revoked successfully': 'Kunci API lama berjaya dibatalkan',
  'Link successfully created.': 'Pautan berjaya dicipta.',
  'Links successfully created.': 'Pautan berjaya dicipta.',
  'Links successfully retrieved.': 'Pautan berjaya diperoleh.',
  'Live chatbots config updated successfully':
    'Konfigurasi chatbot langsung berjaya dikemas kini',
  'LiveKit agent name is not configured':
    'Nama ejen LiveKit tidak dikonfigurasikan',
  'LiveKit credentials are not configured':
    'Kelayakan LiveKit tidak dikonfigurasikan',
  'Logged out successfully': 'Berjaya log keluar',
  'Message ID is required!': 'ID mesej diperlukan!',
  'Message marked as read!': 'Mesej ditandakan sebagai dibaca!',
  'Message not found': 'Mesej tidak ditemui',
  'Message search is currently unavailable. Please try again later.':
    'Carian mesej tidak tersedia buat masa ini. Sila cuba lagi kemudian.',
  'Message search timed out. Please refine your query and try again.':
    'Carian mesej tamat masa. Sila perhalusi pertanyaan anda dan cuba lagi.',
  'Messages sent successfully': 'Mesej berjaya dihantar',
  'Meta agent not found': 'Ejen Meta tidak ditemui',
  'Meta AI is handling this chat. Only Meta can hand a conversation to a human — it does that on its own when it decides one is needed. To stop the agent everywhere, unpublish it.':
    'Meta AI sedang mengendalikan sembang ini. Hanya Meta yang boleh menyerahkan perbualan kepada manusia — ia melakukannya sendiri apabila difikirkan perlu. Untuk menghentikan ejen ini di semua tempat, nyahterbitkannya.',
  'Missing X-Pipecat-Secret header': 'Pengepala X-Pipecat-Secret tiada',
  'Missing X-Voice-Bot-Secret header': 'Pengepala X-Voice-Bot-Secret tiada',
  'Missing authorization header': 'Pengepala authorization tiada',
  'Missing edit session id': 'ID sesi suntingan tiada',
  'Models retrieved successfully': 'Model berjaya diperoleh',
  'Monitoring data fetched successfully': 'Data pemantauan berjaya diambil',
  'No Meta AI agent is configured on this number yet':
    'Belum ada ejen Meta AI yang dikonfigurasikan pada nombor ini',
  'No Meta agent is active': 'Tiada ejen Meta yang aktif',
  'No SIP configuration found': 'Tiada konfigurasi SIP ditemui',
  'No active LLM API key found. Please configure an API key first.':
    'Tiada kunci API LLM aktif ditemui. Sila konfigurasikan kunci API terlebih dahulu.',
  'No active call found': 'Tiada panggilan aktif ditemui',
  'No active employee found to assign chat!':
    'Tiada pekerja aktif ditemui untuk menugaskan sembang!',
  'No billing configured for this organization.':
    'Tiada pengebilan dikonfigurasikan untuk organisasi ini.',
  'No billing data for this period.': 'Tiada data pengebilan untuk tempoh ini.',
  'No business context — pass businessId or use a business-scoped JWT.':
    'Tiada konteks perniagaan — hantar businessId atau gunakan JWT berskop perniagaan.',
  'No businesses found for this org': 'Tiada perniagaan ditemui untuk org ini',
  'No organizations found for this partner':
    'Tiada organisasi ditemui untuk rakan kongsi ini',
  'No call found for this callId': 'Tiada panggilan ditemui untuk callId ini',
  'No call message found to update (early failure)':
    'Tiada mesej panggilan ditemui untuk dikemas kini (kegagalan awal)',
  'No chatbot available for this business':
    'Tiada chatbot tersedia untuk perniagaan ini',
  'No chatbotId provided and no active voice bot configured':
    'Tiada chatbotId diberikan dan tiada bot suara aktif dikonfigurasikan',
  'No hash templates found to delete':
    'Tiada templat hash ditemui untuk dipadamkan',
  'No org found': 'Tiada org ditemui',
  'No organization is associated with this account.':
    'Tiada organisasi dikaitkan dengan akaun ini.',
  'No responseData found in responseMiddleware':
    'Tiada responseData ditemui dalam responseMiddleware',
  'No retainer invoice found for this estimate. Make sure the estimate has been accepted in Zoho first.':
    'Tiada invois retainer ditemui untuk anggaran ini. Pastikan anggaran telah diterima dalam Zoho terlebih dahulu.',
  'No templates found to process': 'Tiada templat ditemui untuk diproses',
  'No valid message content': 'Tiada kandungan mesej yang sah',
  'No voice bot configured': 'Tiada bot suara dikonfigurasikan',
  'Not Enabled.': 'Tidak Didayakan.',
  'Not found.': 'Tidak ditemui.',
  'Nudge scheduled successfully': 'Nudge berjaya dijadualkan',
  'OAuth client successfully created.': 'Klien OAuth berjaya dicipta.',
  'One or more chatbots do not belong to this organization':
    'Satu atau lebih chatbot bukan milik organisasi ini',
  'Only an OWNER can manage business access.':
    'Hanya OWNER yang boleh mengurus akses perniagaan.',
  'Only an OWNER can restore a deleted employee.':
    'Hanya OWNER yang boleh memulihkan pekerja yang telah dipadamkan.',
  'Org ID or business id not found in JWT payload!':
    'ID org atau ID perniagaan tidak ditemui dalam muatan JWT!',
  'Org context missing in request': 'Konteks org tiada dalam permintaan',
  'Org not found': 'Org tidak ditemui',
  'Org pricing updated successfully.': 'Harga org berjaya dikemas kini.',
  'Org-level functions retrieved successfully':
    'Fungsi peringkat org berjaya diperoleh',
  'Org-wide account status is not available for this session.':
    'Status akaun seluruh org tidak tersedia untuk sesi ini.',
  'Organization not found or does not belong to this partner.':
    'Organisasi tidak ditemui atau bukan milik rakan kongsi ini.',
  'Organization not found.': 'Organisasi tidak ditemui.',
  'Outbound call initiated': 'Panggilan keluar dimulakan',
  'PIPECAT_SECRET not configured': 'PIPECAT_SECRET tidak dikonfigurasikan',
  'Participant removal requested': 'Pengeluaran peserta diminta',
  'Partner admin added successfully.':
    'Pentadbir rakan kongsi berjaya ditambah.',
  'Partner admin not found.': 'Pentadbir rakan kongsi tidak ditemui.',
  'Partner admin removed successfully.':
    'Pentadbir rakan kongsi berjaya dialih keluar.',
  'Partner admins fetched successfully.':
    'Pentadbir rakan kongsi berjaya diambil.',
  'Partner businesses fetched successfully.':
    'Perniagaan rakan kongsi berjaya diambil.',
  'Partner context fetched successfully.':
    'Konteks rakan kongsi berjaya diambil.',
  'Partner context not found.': 'Konteks rakan kongsi tidak ditemui.',
  'Partner created successfully.': 'Rakan kongsi berjaya dicipta.',
  'Partner not found.': 'Rakan kongsi tidak ditemui.',
  'Partner orgs fetched successfully.': 'Org rakan kongsi berjaya diambil.',
  'Partner updated successfully.': 'Rakan kongsi berjaya dikemas kini.',
  'Partners fetched successfully.': 'Rakan kongsi berjaya diambil.',
  'Password updated successfully!': 'Kata laluan berjaya dikemas kini!',
  'Patch result reported': 'Hasil patch dilaporkan',
  'Path Does Not Exist': 'Laluan Tidak Wujud',
  'Payload must be a non-empty array of client updates':
    'Muatan mesti merupakan tatasusunan kemas kini pelanggan yang tidak kosong',
  'Phone Number ID or FB Access Token is missing!':
    'ID Nombor Telefon atau Token Akses FB tiada!',
  'Phone number ID or access token is missing on the business profile.':
    'ID nombor telefon atau token akses tiada pada profil perniagaan.',
  'Phone number ID or access token not found':
    'ID nombor telefon atau token akses tidak ditemui',
  'Phone number id or fb access token is missing!':
    'ID nombor telefon atau token akses fb tiada!',
  'Pick any\\n\\n1. Pizza\\n2. Pasta':
    'Pilih mana-mana\\n\\n1. Pizza\\n2. Pasta',
  'Please setup account first': 'Sila sediakan akaun terlebih dahulu',
  'Policy Bazar lead dispatched to LiveKit':
    'Lead Policy Bazar dihantar ke LiveKit',
  'Presigned URL generated': 'Presigned URL dijana',
  'Presigned download URL generated': 'URL muat turun presigned dijana',
  'Presigned upload URL generated': 'URL muat naik presigned dijana',
  'Query executed': 'Pertanyaan dilaksanakan',
  'Query exported to S3': 'Pertanyaan dieksport ke S3',
  'Quick Replies added successfully': 'Balasan Pantas berjaya ditambah',
  'Re-engagement message': 'Mesej penglibatan semula',
  'Real one': 'Yang sebenar',
  'Redirect link not found.': 'Pautan ubah hala tidak ditemui.',
  'Request Failed with Internal Server Error':
    'Permintaan Gagal dengan Ralat Pelayan Dalaman',
  'Retainer invoice activated.': 'Invois retainer diaktifkan.',
  'rollout.enabled is required — agent settings have not been initialized yet':
    'rollout.enabled diperlukan — tetapan ejen belum dimulakan lagi',
  'SIP call accepted': 'Panggilan SIP diterima',
  'SIP call initiated': 'Panggilan SIP dimulakan',
  'SIP call rejected': 'Panggilan SIP ditolak',
  'SIP call terminated': 'Panggilan SIP ditamatkan',
  'SIP call terminated successfully': 'Panggilan SIP berjaya ditamatkan',
  'SIP configuration removed': 'Konfigurasi SIP dialih keluar',
  'SIP configured successfully': 'SIP berjaya dikonfigurasikan',
  'SIP is not configured. Run setup first.':
    'SIP tidak dikonfigurasikan. Jalankan persediaan terlebih dahulu.',
  'SIP trunk not found on LiveKit. Re-run SIP setup (Settings → SIP Calling) to reconnect the trunk.':
    'Trunk SIP tidak ditemui di LiveKit. Jalankan semula persediaan SIP (Tetapan → Panggilan SIP) untuk menyambung semula trunk tersebut.',
  'SMS channel is not yet available': 'Saluran SMS belum tersedia',
  'Search query only contains unsupported characters':
    'Pertanyaan carian hanya mengandungi aksara yang tidak disokong',
  'Send queue temporarily unavailable, retry after a few seconds':
    'Baris gilir penghantaran tidak tersedia buat sementara, cuba semula selepas beberapa saat',
  'Session cleared successfully': 'Sesi berjaya dikosongkan',
  'Session has been logged out': 'Sesi telah dilog keluar',
  'Session info fetched': 'Maklumat sesi diambil',
  'Session logged out successfully': 'Sesi berjaya dilog keluar',
  'Session not found': 'Sesi tidak ditemui',
  'Sessions retrieved successfully': 'Sesi berjaya diperoleh',
  'Settings updated': 'Tetapan dikemas kini',
  'Setup your Facebook account first!':
    'Sediakan akaun Facebook anda terlebih dahulu!',
  'Short URL collision occured. Try again or increase length and try again.':
    'Perlanggaran URL pendek berlaku. Cuba lagi atau tambahkan panjang dan cuba lagi.',
  'Short URL collision occurred. Please try again with a longer hash length.':
    'Perlanggaran URL pendek berlaku. Sila cuba lagi dengan panjang hash yang lebih panjang.',
  'Some employees do not exist!': 'Sesetengah pekerja tidak wujud!',
  'Source and fallback template cannot be the same':
    'Templat sumber dan templat gantian tidak boleh sama',
  'Stored attribute configuration could not be read':
    'Konfigurasi atribut yang disimpan tidak dapat dibaca',
  'Successfully Fetched Attributes': 'Berjaya Mengambil Atribut',
  'Successfully added or updated webhook URL':
    'Berjaya menambah atau mengemas kini URL webhook',
  'Successfully added webhook': 'Berjaya menambah webhook',
  'Successfully created business api-key!':
    'Berjaya mencipta api-key perniagaan!',
  'Successfully deleted clients': 'Berjaya memadam pelanggan',
  'Successfully deleted scheduled!': 'Berjaya memadam jadual!',
  'Successfully deleted session!': 'Berjaya memadam sesi!',
  'Successfully deleted webhook': 'Berjaya memadam webhook',
  'Successfully deleted webhook URL': 'Berjaya memadam URL webhook',
  'Successfully fetched all businesses.': 'Berjaya mengambil semua perniagaan.',
  'Successfully fetched all employees.': 'Berjaya mengambil semua pekerja.',
  'Successfully fetched all orgs.': 'Berjaya mengambil semua organisasi.',
  'Successfully fetched analytics!': 'Berjaya mengambil analitik!',
  'Successfully fetched call settings!': 'Berjaya mengambil tetapan panggilan!',
  'Successfully fetched form responses': 'Berjaya mengambil respons borang',
  'Successfully fetched pricing analytics!':
    'Berjaya mengambil analitik harga!',
  'Successfully generated CSV file for Cars24 delivery report':
    'Berjaya menjana fail CSV untuk laporan penghantaran Cars24',
  'Successfully logged in!': 'Berjaya log masuk!',
  'Successfully previewed the flow!': 'Berjaya membuat pratonton aliran!',
  'Successfully queued messages':
    'Berjaya memasukkan mesej ke dalam baris gilir',
  'Successfully retrieved campaign Stats.':
    'Berjaya mendapatkan Statistik kempen.',
  'Successfully retrieved campaign list': 'Berjaya mendapatkan senarai kempen',
  'Successfully retrieved client attributes':
    'Berjaya mendapatkan atribut pelanggan',
  'Successfully retrieved client details':
    'Berjaya mendapatkan butiran pelanggan',
  'Successfully retrieved client list': 'Berjaya mendapatkan senarai pelanggan',
  'Successfully retrieved group list': 'Berjaya mendapatkan senarai kumpulan',
  'Successfully retrieved message': 'Berjaya mendapatkan mesej',
  'Successfully retrieved messages': 'Berjaya mendapatkan mesej',
  'Successfully scheduled messages!': 'Berjaya menjadualkan mesej!',
  'Successfully send read status!': 'Berjaya menghantar status dibaca!',
  'Successfully start heltarbot flow!': 'Berjaya memulakan aliran heltarbot!',
  'Successfully update jwt token': 'Berjaya mengemas kini token jwt',
  'Successfully updated call settings!':
    'Berjaya mengemas kini tetapan panggilan!',
  'Successfully updated employee.': 'Berjaya mengemas kini pekerja.',
  'Successfully updated org.': 'Berjaya mengemas kini organisasi.',
  'Successfully updated the flow!': 'Berjaya mengemas kini aliran!',
  'Support email config fetched successfully.':
    'Konfigurasi e-mel sokongan berjaya diambil.',
  'Support email config updated successfully.':
    'Konfigurasi e-mel sokongan berjaya dikemas kini.',
  'Sure!': 'Sudah tentu!',
  'System prompt generated successfully': 'Prompt sistem berjaya dijana',
  'Target business is in a different organisation.':
    'Perniagaan sasaran berada dalam organisasi yang berbeza.',
  'Target business not found.': 'Perniagaan sasaran tidak ditemui.',
  'Template analytics retrieved successfully from ClickHouse':
    'Analitik templat berjaya diperoleh daripada ClickHouse',
  'Template category updates fetched successfully':
    'Kemas kini kategori templat berjaya diambil',
  'Template cost analytics retrieved successfully':
    'Analitik kos templat berjaya diperoleh',
  'Template details retrieved successfully from ClickHouse':
    'Butiran templat berjaya diperoleh daripada ClickHouse',
  'Template message analytics retrieved successfully':
    'Analitik mesej templat berjaya diperoleh',
  'Testing custom error': 'Menguji ralat tersuai',
  "The 'OWNER' role must have 'permissionManagement' enabled.":
    "Peranan 'OWNER' mesti mempunyai 'permissionManagement' yang didayakan.",
  'The GSTIN has an unrecognized state code.':
    'GSTIN ini mempunyai kod negeri yang tidak dikenali.',
  'This API is not accessible with an API key.':
    'API ini tidak boleh diakses dengan kunci API.',
  'This account has been deleted. Please contact your administrator.':
    'Akaun ini telah dipadamkan. Sila hubungi pentadbir anda.',
  'This action requires a logged-in session, not an API key.':
    'Tindakan ini memerlukan sesi log masuk, bukan kunci API.',
  'This email address is already linked to another contact':
    'Alamat e-mel ini telah dipautkan kepada kenalan lain',
  'This embed link has expired or was already used. Reopen it from your CRM.':
    'Pautan benam ini telah tamat tempoh atau telah digunakan. Buka semula daripada CRM anda.',
  'Password is required to activate your account.':
    'Kata laluan diperlukan untuk mengaktifkan akaun anda.',
  'This invite is invalid or has expired.':
    'Jemputan ini tidak sah atau telah tamat tempoh.',
  'Timed out while waiting for function update to finish':
    'Tamat masa semasa menunggu kemas kini fungsi selesai',
  'Token and new password are required!':
    'Token dan kata laluan baharu diperlukan!',
  'Token invalid or expired!': 'Token tidak sah atau telah tamat tempoh!',
  'Token not provided': 'Token tidak diberikan',
  'Token successfully created.': 'Token berjaya dicipta.',
  'Too many fields.': 'Terlalu banyak medan.',
  'Too many files. Please upload fewer files.':
    'Terlalu banyak fail. Sila muat naik fail yang lebih sedikit.',
  'Too many parts in multipart data.':
    'Terlalu banyak bahagian dalam data multipart.',
  'Transaction history retrieved successfully':
    'Sejarah transaksi berjaya diperoleh',
  'Transcript saved to call message': 'Transkrip disimpan ke mesej panggilan',
  'Unable to dispatch Policy Bazar lead to LiveKit':
    'Tidak dapat menghantar petunjuk Policy Bazar ke LiveKit',
  'Unexpected file field.': 'Medan fail tidak dijangka.',
  'Update Template is not supported. Please make new template.':
    'Kemas kini Templat tidak disokong. Sila buat templat baharu.',
  'Updated widget allowed origins':
    'Senarai origin yang dibenarkan untuk widget telah dikemas kini',
  'Upload failed': 'Muat naik gagal',
  Uploaded: 'Dimuat naik',
  'User ID and token are required': 'ID pengguna dan token diperlukan',
  'User ID is required': 'ID pengguna diperlukan',
  'User not found': 'Pengguna tidak ditemui',
  'VOICE_BOT_SECRET not configured': 'VOICE_BOT_SECRET tidak dikonfigurasikan',
  'Valid businessId is required.': 'businessId yang sah diperlukan.',
  'Valid employee ID is required.': 'ID pekerja yang sah diperlukan.',
  'Valid org ID is required.': 'ID organisasi yang sah diperlukan.',
  'Valid orgId is required.': 'orgId yang sah diperlukan.',
  'Valid partner ID is required.': 'ID rakan kongsi yang sah diperlukan.',
  'Valid version number is required': 'Nombor versi yang sah diperlukan',
  'Voice bot test room ready': 'Bilik ujian bot suara sedia',
  'Voice call fetched': 'Panggilan suara diambil',
  'Voice calls listed': 'Panggilan suara disenaraikan',
  'Wallet information retrieved successfully':
    'Maklumat dompet berjaya diperoleh',
  'We could not create this account. It may already exist — try logging in.':
    'Kami tidak dapat mencipta akaun ini. Ia mungkin sudah wujud — cuba log masuk.',
  'Webhook processed': 'Webhook telah diproses',
  'Welcome!': 'Selamat datang!',
  'What is your name?': 'Siapakah nama anda?',
  'WhatsApp notification sent successfully':
    'Pemberitahuan WhatsApp berjaya dihantar',
  'Whatsapp api signUp again to run this operation':
    'Whatsapp api signUp semula untuk menjalankan operasi ini',
  'You are not authorized to access this resource':
    'Anda tidak dibenarkan mengakses sumber ini',
  'You can only fetch your own employee record.':
    'Anda hanya boleh mengambil rekod pekerja anda sendiri.',
  'You can only grant access to businesses you can access.':
    'Anda hanya boleh memberikan akses kepada perniagaan yang boleh anda akses.',
  'You cannot create tags. You can directly update the tags options':
    'Anda tidak boleh mencipta tag. Anda boleh terus mengemas kini pilihan tag',
  'You do not have access to this business. Contact your account owner.':
    'Anda tidak mempunyai akses kepada perniagaan ini. Hubungi pemilik akaun anda.',
  'You do not have partner dashboard access.':
    'Anda tidak mempunyai akses papan pemuka rakan kongsi.',
  'You do not have permission to log out other users.':
    'Anda tidak mempunyai kebenaran untuk melog keluar pengguna lain.',
  'Your account has no business access. Please contact your account owner.':
    'Akaun anda tiada akses perniagaan. Sila hubungi pemilik akaun anda.',
  'Your account is ready. You can now log in.':
    'Akaun anda sudah sedia. Anda kini boleh log masuk.',
  'Your admin access is read-only. This action is not permitted.':
    'Akses pentadbir anda adalah baca sahaja. Tindakan ini tidak dibenarkan.',
  'Zoho customers fetched successfully.': 'Pelanggan Zoho berjaya diambil.',
  'Zoho estimate fetched successfully.': 'Anggaran Zoho berjaya diambil.',
  'Zoho estimate not found.': 'Anggaran Zoho tidak ditemui.',
  'Zoho estimates fetched successfully.': 'Anggaran Zoho berjaya diambil.',
  'attribute parameter is missing in the request.':
    'parameter attribute tiada dalam permintaan.',
  'businessId is required and must be a number.':
    'businessId diperlukan dan mestilah nombor.',
  'businessId, clientWaNumber, and callUuid are required':
    'businessId, clientWaNumber, dan callUuid diperlukan',
  'businessIds must be an array.': 'businessIds mestilah tatasusunan.',
  'callId and either phoneNumberId or businessId are required':
    'callId dan sama ada phoneNumberId atau businessId diperlukan',
  'callId is required': 'callId diperlukan',
  'chatbotId and phoneNumberId or businessId are required':
    'chatbotId dan phoneNumberId atau businessId diperlukan',
  'chatbotId is required': 'chatbotId diperlukan',
  'clientWaNumber and businessId are required.':
    'clientWaNumber dan businessId diperlukan.',
  'clientWaNumber and phoneNumberId are required.':
    'clientWaNumber dan phoneNumberId diperlukan.',
  'clientWaNumber is required': 'clientWaNumber diperlukan',
  'clientWaNumbers parameter is missing in the request.':
    'parameter clientWaNumbers tiada dalam permintaan.',
  'codeZipBase64 payload is empty': 'muatan codeZipBase64 kosong',
  'contactId is required': 'contactId diperlukan',
  'employeeId is required': 'employeeId diperlukan',
  'endDate must not be before startDate.':
    'endDate tidak boleh sebelum startDate.',
  'expirationDays (1-30) is required when action=pin':
    'expirationDays (1-30) diperlukan apabila action=pin',
  'flowDefinition is required for flow chatbots':
    'flowDefinition diperlukan untuk chatbot aliran',
  'function not found for this org':
    'fungsi tidak ditemui untuk organisasi ini',
  'hasAccess must be a boolean.': 'hasAccess mestilah boolean.',
  'invocation failed': 'invokasi gagal',
  'media.url must be a Heltar-hosted upload URL':
    'media.url mestilah URL muat naik yang dihoskan oleh Heltar',
  'name, chatbotId, and either phoneNumberId or businessId are required':
    'name, chatbotId, dan sama ada phoneNumberId atau businessId diperlukan',
  'oldattribute and newattribute in case of tags should be same.':
    'oldattribute dan newattribute bagi kes tag hendaklah sama.',
  'orgId not found in JWT': 'orgId tidak ditemui dalam JWT',
  'registrationNo and mobileNumber are required':
    'registrationNo dan mobileNumber diperlukan',
  'registrationNumber and mobile are required':
    'registrationNumber dan mobile diperlukan',
  'roomName is required': 'roomName diperlukan',
  'since must be an epoch timestamp': 'since mestilah cap masa epoch',
  'startDate and endDate are required': 'startDate dan endDate diperlukan',
  'startDate and endDate must be valid dates.':
    'startDate dan endDate mestilah tarikh yang sah.',
  'startDate and endDate query params are required (YYYY-MM-DD)':
    'parameter pertanyaan startDate dan endDate diperlukan (YYYY-MM-DD)',
  'startDate must be before endDate': 'startDate mestilah sebelum endDate',
  'tags attribute canot be deleted.': 'atribut tags tidak boleh dipadamkan.',
  'templateName and date are required': 'templateName dan date diperlukan',
  'wamid query parameter is required': 'parameter pertanyaan wamid diperlukan',
  'zohoEstimateId is required': 'zohoEstimateId diperlukan',
  'zohoEstimateId is required.': 'zohoEstimateId diperlukan.',
  'Failed to deploy code. Please try again.':
    'Gagal mengatur guna kod. Sila cuba lagi.',
  'Failed to download the code bundle. Please try again.':
    'Gagal memuat turun bundle kod. Sila cuba lagi.',
  'The deployment did not complete. Please try again.':
    'Pengaturgunaan tidak selesai. Sila cuba lagi.',
  'The function could not be created. Please check your configuration or try again.':
    'Fungsi tidak dapat dicipta. Sila semak konfigurasi anda atau cuba lagi.',
};
